module.exports = __webpack_public_path__ + "static/media/offline.d92d36c6.ico";